import type { ComponentCustomProps } from 'vue';

import Popup from './popup/popup.vue';
import PopupOpener from './popup/opener.vue';
import PopupListItem from './popup/listItem.vue';
import PopupWidgetInput from './popup/widgetInput.vue';
import PopupAlert from './alert/alert.vue';
import PopupConfirm from './confirm/confirm.vue';
import PopupPrompt from './prompt/prompt.vue';

export const TopPopup = Popup as typeof Popup & ComponentCustomProps;
export const TopPopupOpener = PopupOpener as typeof PopupOpener & ComponentCustomProps;
export const TopPopupListItem = PopupListItem as typeof PopupListItem & ComponentCustomProps;
export const TopPopupWidgetInput = PopupWidgetInput as typeof PopupWidgetInput & ComponentCustomProps;
export const TopPopupAlert = PopupAlert as typeof PopupAlert & ComponentCustomProps;
export const TopPopupConfirm = PopupConfirm as typeof PopupConfirm & ComponentCustomProps;
export const TopPopupPrompt = PopupPrompt as typeof PopupPrompt & ComponentCustomProps;
